import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from '@/hooks/use-toast';
import { useEffect, useState } from 'react';

interface AdminRouteProps {
  children: React.ReactNode;
  requireProductsAccess?: boolean;
}

export const AdminRoute = ({ children, requireProductsAccess = false }: AdminRouteProps) => {
  const { isAuthenticated, isAdmin, canAccessProducts } = useAuth();
  const [hasShownToast, setHasShownToast] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated && !isAdmin() && !hasShownToast) {
      toast({
        title: "Access Denied",
        description: "You don't have permission to access the admin panel",
        variant: "destructive",
      });
      setHasShownToast(true);
    }
  }, [isAuthenticated, isAdmin, hasShownToast]);

  useEffect(() => {
    if (isAuthenticated && isAdmin() && requireProductsAccess && !canAccessProducts && !hasShownToast) {
      toast({
        title: "Access Denied",
        description: "You don't have permission to access Products",
        variant: "destructive",
      });
      setHasShownToast(true);
    }
  }, [isAuthenticated, isAdmin, canAccessProducts, requireProductsAccess, hasShownToast]);

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  if (!isAdmin()) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (requireProductsAccess && !canAccessProducts) {
    return <Navigate to="/admin/orders" replace />;
  }

  return <>{children}</>;
};
